import React, { forwardRef } from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useLeaderboardData from "hooks/useLeaderboardData";
import FlaggedHoursTable from "./FlaggedHoursTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "assets/scss/printflaggedhoursreport.scss";
import PrintableFlaggedHoursReports from "./PrintableFlaggedHoursReports";

const LeaderboardReports = forwardRef((props, ref) => {
  const { reportDetails, reportAssignees } = useLeaderboardData();
  const { reports } = reportDetails;

  return (
    <Box
      height={"calc(100vh - 48px - 64px)"}
      width="100%"
    >
      <PerfectScrollbar>
        {reports.length > 0 ? (
          <>
            <div style={{ display: "none" }}>
              <Box mx={6} ref={ref}>
                <PrintableFlaggedHoursReports />
              </Box>
            </div>
            <Box mx={6}>
              {reports
                .filter(
                  (i) =>
                    i.totalFlagged !== null && reportAssignees.includes(i.name)
                )
                .map((item, index) => (
                  <FlaggedHoursTable data={item} />
                ))}
            </Box>
          </>
        ) : (
          reports.length === 0 && (
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h2" align="center">
                  Select an Assignee or Valid Date Range
                </Typography>
                <Typography variant="h4" align="center">
                  Note: Assignees with ZERO flagged hours within the selected
                  date range will not display on this report
                </Typography>
              </Grid>
            </Grid>
          )
        )}
      </PerfectScrollbar>
    </Box>
  );
});

export default LeaderboardReports;
